export default __webpack_public_path__ + "static/media/lock.e2f22bde.svg";